(function () {
    "use strict";
    angular
        .module('harriApp')
        .controller("I9ResendOptionsModal", I9ResendOptionsModal);

    I9ResendOptionsModal.$inject = ['$scope', 'modalData', 'fillNextDocument', 'addToDocumentsWithoutExtraInfo', 'hideI9Modal'];

    function I9ResendOptionsModal($scope, modalData, fillNextDocument, addToDocumentsWithoutExtraInfo, hideI9Modal) {
        var self = this;

        self.showErr = false;

        self.hide = function () {
            hideI9Modal();
        };

        self.sendReminder = function (type) {
            self.showErr = false;
            if (!type) {
                self.showErr = true;
                return;
            } else if (type === 'NEW') {
                $scope.$hide();
                addToDocumentsWithoutExtraInfo();
                fillNextDocument();
                return;
            }

            var reminderType = (type === 'CORRECTION' ? OnBoardingAPI.DOC_REMINDER_TYPE.CORRECTION : OnBoardingAPI.DOC_REMINDER_TYPE.MISSING_INFO);

            self.isLoading = true;

            OnBoardingAPI.documentReminder(modalData.i9DocumentId, reminderType, self.comment)
                .then(function (data) {
                    self.isLoading = false;
                    $scope.$hide();
                    fillNextDocument();
                    HNotifications.show({
                        title: $filter("translate")("Success"),
                        desc: $filter("translate")("i9 document resent successfully"),
                        icon: "fa-check-circle",
                        type: "success"
                    });
                }, function (res) {
                    self.isLoading = false;
                    $scope.$hide();
                    console.error("An Error with Doc Action API:", res);
                    HNotifications.show({
                        title: $filter("translate")("Error"),
                        desc: $filter("translate")("failed to resent i9 document"),
                        icon: "fa-times",
                        type: "danger"
                    });
                });
        };
    }
})();
